"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
const useStyles = props => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    layout = 'popup'
  } = props;
  const ccNoSchoolStyle = (0, _react.useMemo)(() => {
    const mobileLayoutProps = () => {
      if (layout === 'inline' && isMobileView) {
        return {
          height: '100%'
        };
      }
      return {};
    };
    const ccNoSchool = (0, _css.css)({
      ...mobileLayoutProps()
    });
    return ccNoSchool;
  }, [isMobileView, layout]);
  return {
    'cc-NoSchool': ccNoSchoolStyle
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;